module.exports = __webpack_public_path__ + "static/img/3.03581b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/3.png
// module id = Z1rc
// module chunks = 0